import React from 'react';
import '../App.css';
import {MantineProvider} from '@mantine/core'
import {routeArray} from '../route-config'
import {Navigate, Route, Routes} from 'react-router-dom'
import {useAuthRedirect} from "../hooks/use-auth-redirect";
import {NotificationsProvider} from '@mantine/notifications';
import {useTypedSelector} from "../store";

const routes = routeArray.map((r) => (
  <Route key={r.path} path={r.path} element={<r.page/>}/>
))

const App = () => {
  const {profile} = useTypedSelector((state) => state.auth)

  const redirect = useAuthRedirect(profile, false);

  if (redirect !== undefined) return <Navigate to={redirect}/>;

  return (
    <MantineProvider
      theme={{
        fontFamily: 'Verdana, sans-serif',
        fontFamilyMonospace: 'Monaco, Courier, monospace',
        headings: {fontFamily: 'Greycliff CF, sans-serif'},
      }}
    >
      <NotificationsProvider>
        <Routes>
          {routes}
        </Routes>
      </NotificationsProvider>
    </MantineProvider>
  );
}

export default App;
